import { consoleInfo, getNodes } from '@gravityforms/utils';

const els = {
	inputs: getNodes( 'geolocation_submitter_location', true ),
};

/**
 * @function updateInputWithLocation
 * @description Callback to update each hidden input on the page forms with location info.
 *
 * @param {object} pos The location data object from the Geolocation API.
 *
 * @return {void}
 */
const updateInputWithLocation = ( pos ) => {
	els.inputs.forEach( ( el ) => {
		el.value = JSON.stringify( { lat: pos.coords.latitude, lng: pos.coords.longitude } );
	} );

	consoleInfo( 'Gravity Forms Geolocation JS: Geolocation successfully fetched.' );
};

/**
 * @function updateInputWithErrorMessage
 * @description Callback to update each hidden input on the page forms with the geolocation error message.
 *
 * @param {object} pos The error message object from the Geolocation API.
 *
 * @return {void}
 */
const updateInputWithErrorMessage = ( message ) => {
	els.inputs.forEach( ( el ) => {
		el.value = JSON.stringify( message );
	} );

	consoleInfo( 'Gravity Forms Geolocation JS: Geolocation could not be fetched. Saved error message: ' + message.message );
};

/**
 * @function geoLocateUserLocation
 * @description Use a Geolocation API service to geolocate based on IP (not yet implemented)
 *
 * @return {void}
 */
const geoLocateUserLocation = ( err ) => {
	updateInputWithErrorMessage( { message: err.message } );
	// @todo - update to allow using APIs to get location when HTML5 is not available.
	consoleInfo( 'Gravity Forms Geolocation JS: Geolocation not available, aborting.' );
};

/**
 * @function getUserLocation
 * @description Get the user's location using either the HTML5 Geolocation API, or another service.
 *
 * @return {void}
 */
const getUserLocation = () => {
	if ( ! navigator.geolocation ) {
		geoLocateUserLocation( { message: 'Browser does not support geolocation.' } );
		return;
	}

	// Set a timeout so that browsers like Brave will fall back to the geoLocateUserLocation() method on failure.
	navigator.geolocation.getCurrentPosition( updateInputWithLocation, geoLocateUserLocation, { timeout: 1000 } );
};

/**
 * @function init
 * @description Initialize the various pieces of functionality.
 *
 * @return {void}
 */
const init = () => {
	if ( ! els.inputs.length ) {
		return;
	}

	getUserLocation();

	consoleInfo( 'Gravity Forms Geolocation JS: Initialized user location script.' );
};

export default init;
